import { jsx as _jsx } from "react/jsx-runtime";
import { SettingSwitcher } from './setting-switcher.js';
import { useTheme } from './theme-provider.js';
/** App-local appearance preference, with the shared setting-row presentation. */
export function ThemeSwitcher({ labels, surface = 'card', className, showLabel = false }) {
    const { preference, setPreference } = useTheme();
    return _jsx(SettingSwitcher, { "data-testid": "theme-switcher", icon: "appearance", "aria-label": labels.label, surface: surface, showLabel: showLabel, className: className, value: preference, onValueChange: setPreference, options: ['light', 'dark', 'system'].map(value => ({ value, label: labels[value] })) });
}
//# sourceMappingURL=theme-switcher.js.map